import React, { useEffect, useState } from 'react'
import { FaArrowLeft } from "react-icons/fa";
import { IoMicSharp } from "react-icons/io5";
import VendorProfileCard from '../vendorProfileCard/vendorProfileCard';
import { useLocation, useNavigate } from 'react-router-dom';
import NodeaxiosInstance from '../../Services/nodeaxios';
import vendorNotFound from "../../Assets/Images/icons/NoMerchantFound.png";
import p_nav_previous from "../../Assets/Images/p_nav_previous.svg";
import VoiceSearchInput from '../VoiceSearchInput/VoiceSearchInput';
import HubProfileCard from '../vendorProfileCard/hubProfileCard';
import { useSelector } from 'react-redux';


const SingleDomainSearch = () => {
    const navigate = useNavigate()
    const { state } = useLocation();
    const item = state?.item;
    const fil_location = state?.fil_location

    const [inputSearchValue, setInputSearchValue] = useState("");
    const [fil_category, set_fil_category] = useState([]);
    const [vendorList, setVendorList] = useState([])
    const [pageCount, setPageCount] = useState(1)
    const [searchResults, setSearchResults] = useState([])
    const [isSearching, setIsSearching] = useState(false);
    const [showSearch, setShowsearch] = useState(false)
    const Loginstate = useSelector((state) => state);
    const [userData, serUserData] = useState(Loginstate?.userAuth?.user);
    const [hasMore, setHasMore] = useState(true);
    const [isLoadingMore, setIsLoadingMore] = useState(false);
    const [totalPages, setTotalPages] = useState(1);


    useEffect(() => {
        // if (fil_category.length > 0) {
        searchByVendor(1);
        // }else{
        //     setVendorList([])
        // }
    }, [fil_category, inputSearchValue]);

    const handleScroll = (e) => {
        const { scrollTop, scrollHeight, clientHeight } = e.target;

        if (scrollTop + clientHeight >= scrollHeight - 50 &&
            !isLoadingMore && !isSearching && hasMore) {
            const nextPage = pageCount + 1;

            setPageCount(nextPage);

            searchByVendor(nextPage);


        }
    };


    // const searchByVendor = async (page) => {
    //     const searchText = inputSearchValue?.trim();
    //     // if (!searchText) {
    //     //     setVendorList([]); 
    //     //     return;
    //     // } 

    //     const reqData = {
    //         user_location: fil_location?.latlng || "",
    //         search_name: searchText,
    //         search_type: item?.vendor_type_id || 0,
    //         search_category: fil_category.join(',') || '',
    //         current_page: page == 0 ? 1 : page,
    //     };
    //     page == 1 ? setIsSearching(true) : setIsLoadingMore(true);
    //     console.log('reqData------', reqData);

    //     try {
    //         setVendorList([]);

    //         const response = await NodeaxiosInstance.get("/search", {
    //             params: reqData,
    //             headers: {
    //                 Authorization: userData?.token,
    //             },
    //         });

    //         const results = response?.data?.search_results || [];
    //         const total_pages = response?.data?.total_pages ?? 0;

    //         setTotalPages(total_pages);

    //         if (total_pages == 0 || results == '') {
    //             setHasMore(false);

    //         } else {
    //             setHasMore(true);
    //         }
    //         const currentType = item?.vendor_type_id;
    //         if (Number(response?.data?.search_type) == Number(currentType) || response?.data?.search_type == 0) {
    //             if (page == 1) {
    //                 setVendorList(results);
    //             } else {
    //                 setVendorList(prev => {
    //                     const combined = [...prev, ...results];
    //                     const unique = combined.filter((item, index, self) => index == self.findIndex(t => t.vendor_id == item.vendor_id));
    //                     return unique;
    //                 });
    //             }
    //         }

    //         return response.data;

    //     } catch (error) {
    //         console.error("Search API error:", error);
    //         setVendorList([]);
    //     } finally {
    //         setIsSearching(false);
    //         setIsLoadingMore(false);
    //     }
    // };

    // const handelSelectcategory = (id) => {
    //     const updatedCategories = fil_category?.includes(id)
    //         ? fil_category.filter(catId => catId !== id)
    //         : [...(fil_category || []), id];

    //     set_fil_category(updatedCategories);
    //     searchByVendor(updatedCategories);
    // };


    const searchByVendor = async (page = 1) => {
        const searchText = inputSearchValue?.trim();
        page == 1 ? setIsSearching(true) : setIsLoadingMore(true);

        const reqData = {
            user_location: fil_location?.latlng || "",
            search_name: searchText,
            search_type: item?.vendor_type_id || 0,
            search_category: fil_category.join(',') || '',
            current_page: page == 0 ? 1 : page,
        };



        try {
            const response = await NodeaxiosInstance.get("/search", {
                params: reqData,
                headers: { Authorization: userData?.token },
            });

            const total_pages = response?.data?.total_pages ?? 0;
            const results = response?.data?.search_results ?? [];

            setTotalPages(total_pages);

            if (total_pages == 0 || results == '') {
                setHasMore(false);

            } else {
                setHasMore(true);
            }
            const currentType = item?.vendor_type_id;
            // if (Number(response?.data?.search_type) == Number(currentType) || response?.data?.search_type == 0) {
            if (page == 1) {
                setVendorList(results);
            } else {
                setVendorList(prev => {
                    const combined = [...prev, ...results];
                    const unique = combined.filter((item, index, self) => index == self.findIndex(t => t.vendor_id == item.vendor_id));
                    return unique;
                });
            }
            // }
            //  else if (Number(response?.data?.search_type) != Number(param?.vendor_type_id)) {
            //   setVendorList([]);

            // }

        } catch (error) {
            console.error("Search API error:", error);
        } finally {
            setIsSearching(false);
            setIsLoadingMore(false);
        }
    };
    const handelSelectcategory = (id) => {
        const numId = id;

        set_fil_category(prev => {
            if (prev.includes(numId)) {
                return prev.filter(item => item != numId); // deselect
            }
            return [...prev, numId]; // select
        });
    };
 



    return (
        <div>
            <div className='singleDomainFillter bg-white '>
                <div className="d-flex justify-content-start navBar align-items-center p-3">
                    <div className="d-flex justify-content-between align-items-center text-white ms-2 me-2 " onClick={() => navigate(-1)}>
                        <img
                            src={p_nav_previous}
                            width={"20px"}
                            height={"16px"}
                            alt="Previous Button"
                            role="button"
                        />
                        <div className="ff-balooPaaji2-bold text-dark fs-20 ms-1 ps-1">{item?.vendor_type_name}</div>
                    </div>
                </div>

                <div className='p-2 h-100'>
                    {/* <div className="searchStores p-2">
                        <div className="inputWrapper">
                            <input type="text" className="searchInput" placeholder="Search Store Name, ID" />
                        </div>
                        <div className="searchMicIcon">
                            <IoMicSharp size={20} />
                        </div>
                    </div> */}

                    <div className="p-1">
                        <div onClick={() => setShowsearch(true)}>
                            <VoiceSearchInput
                                value={inputSearchValue}
                                setInputSearchValue={setInputSearchValue}
                                fromPage={item?.vendor_type_name}

                            />
                        </div>
                    </div>
                    {item?.vendor_categories?.length > 1 &&
                        <div className="d-flex flex-wrap mt-3">
                            {item?.vendor_categories?.map((cate) => {
                                const isActive = fil_category
                                    .map(Number)
                                    .includes(Number(cate?.vendor_category_id));
                                return (
                                    <div key={cate?.vendor_category_id} className={` me-2 mb-2 ${isActive ? 'seletedvendorcategorie' : 'serviceCategoryBox'}`}
                                        onClick={() => handelSelectcategory(cate?.vendor_category_id)} >
                                        <img src={cate?.vendor_category_image} width="30" height="30" alt="" />
                                        <span className='ms-2'>{cate?.vendor_category_name}</span>
                                    </div>
                                );
                            })}
                        </div>
                    }

                    {/* <div className="scroller-style-y mt-3">
                        {isSearching ? (
                            <div className="d-flex justify-content-center align-items-center h-100  ff-poppins-medium fs-13">Searching...</div>
                        ) : vendorList.length > 0 ?
                            vendorList.map((item, index) => {
                                const isVendor = item.type === "VENDOR";
                                console.log('vendor type--------', item);

                                const key = `${isVendor ? item.vendor_id : item.hub_id}-${index}`;
                                return isVendor ?
                                    <VendorProfileCard
                                        key={item.vendor_id}
                                        data={item}
                                    /> :
                                    <HubProfileCard
                                        key={item.hub_id}
                                        data={item}
                                    />
                            })
                            : (
                                <div className="d-flex justify-content-center align-items-center h-100">
                                    <div className="text-center" >
                                        <img src={vendorNotFound} className="vendorNotFound" />
                                        <div className="ff-poppins-light fs-13 mt-2">
                                            Oops! No merchant found.
                                        </div>
                                        {inputSearchValue && (
                                            <p className="ff-poppins-light fs-13">
                                                for "{inputSearchValue ? inputSearchValue : fil_category}"
                                            </p>
                                        )}
                                    </div>
                                </div>
                            )}
                    </div> */}

                    <div className="mt-3">
                        <div className="  d-flex flex-column" style={{ marginBottom: "265px" }}>
                            <div className="scroller-style-y flex-grow-1 d-flex flex-column" onScroll={handleScroll}  >
                                {isSearching ? (
                                    <div className="ff-poppins-medium fs-13 d-flex justify-content-center align-items-center w-100" >
                                        Searching...
                                    </div>
                                ) : vendorList.length > 0 ? (

                                    <div style={{ marginBottom: '300px' }}>
                                        {vendorList.map((item, index) => {
                                            const isVendor = item.type === "VENDOR";
                                            const key = `${isVendor ? item.vendor_id : item.hub_id}-${index}`;

                                            return isVendor ? (
                                                <VendorProfileCard
                                                    key={item.vendor_id}
                                                    data={item}
                                                />
                                            ) : (
                                                <HubProfileCard
                                                    key={item.hub_id}
                                                    data={item}
                                                />
                                            );
                                        })}

                                        {isLoadingMore && (
                                            <div className="text-center mt-2 fs-13">
                                                Loading more...
                                            </div>
                                        )}
                                    </div>
                                ) : (
                                    <div className="no-vendor-container">
                                        <div className="text-center">
                                            <img src={vendorNotFound} className="vendorNotFound" />

                                            <div className="ff-poppins-light fs-13 mt-2">
                                                Oops! No merchant found.
                                            </div>

                                            {inputSearchValue && (
                                                <p className="ff-poppins-light fs-13">
                                                    for "{inputSearchValue || fil_category}"
                                                </p>
                                            )}
                                        </div>
                                    </div>
                                )}

                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div >
    )
}

export default SingleDomainSearch